import { backlogViewType } from "./constants";
import GridRequests from "./gridRequests";

const AllRequests = ({ ...props }) => {
  const { reloadData } = props;
  return (
    <>
      <GridRequests type={backlogViewType.allRequests} reloadData={reloadData} />
    </>
  );
}

export default AllRequests;